import { PopupMenuList } from 'shared/components/ui/popup-menu';
import styled from 'styled-components';

export const ChildrenContainer = styled(PopupMenuList)`
  padding: 0;
`;
